<div class="officer-comment-section">
  <div class="comment-icon" aria-hidden="true">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="20"
        cy="20"
        r="19"
        stroke="currentColor"
        stroke-width="2"
        opacity="0.1"
        fill="none" />
      <circle
        cx="20"
        cy="20"
        r="14"
        stroke="currentColor"
        stroke-width="2"
        opacity="0.3"
        fill="none" />
      <circle
        cx="20"
        cy="20"
        r="9"
        stroke="currentColor"
        stroke-width="2"
        fill="none" />
      <path
        d="M20 15V23M20 26H20.01"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </div>
  <div class="comment-content">
    <div class="comment-label">{{ label }}</div>
    <div class="comment-text" [innerHTML]="safeComment"></div>
  </div>
</div>
